import { render, staticRenderFns } from "./createOrdersViewWizard.vue?vue&type=template&id=67fc85aa"
import script from "./createOrdersViewWizard.vue?vue&type=script&lang=js"
export * from "./createOrdersViewWizard.vue?vue&type=script&lang=js"
import style0 from "./createOrdersViewWizard.vue?vue&type=style&index=0&id=67fc85aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports